import Vue from 'vue'

import App from './App.vue'
import router from "./components/router/routes"
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import VueQuillEditor from 'vue-quill-editor'
import Array_Val from "./assets/js/common.js"
import urls from "./components/utils/urls"
import store from "./components/store/store"
import echarts from 'echarts'
Vue.prototype.$echarts = echarts
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.prototype.Array_Val = Array_Val
Vue.use(VueQuillEditor)

Vue.use(Element)

Vue.prototype.$url = urls
Vue.config.productionTip = false




new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
